export const RETAIL_ELECTRON_API_KEY = 'retailElectronAPI';

export const RetailElectronAPI = window[RETAIL_ELECTRON_API_KEY] as IRetailElectronAPI;

export interface IRetailElectronAPI {
  log(level: string, msg: string, jsonPayload: any): void;
  getEnvironmentVariables(): ILaneEnvironmentVars;
  getCustomerDisplayController(): ICustomerDisplayController;
  getMainWindowController(): IMainWindowController;
}

export interface ILaneEnvironmentVars {
  API_HOST: string;
  API_PORT: string;
  TOUCHPOINT_ID?: string;
  REACT_APP_REDIRECT_URL?: string;
  REACT_APP_LOGOFF_REDIRECT_URL?: string;
  REACT_APP_IDENTITY_CLIENT_SECRET?: string;
  REACT_APP_IDENTITY_CLIENT_ID?: string;
  REACT_APP_ENABLE_TRACING?: string;
  REACT_APP_TOKEN_EXPIRATION_RENEWAL_TIME: string;
  REACT_APP_ENABLE_MANUAL_WEIGHT_FOR_SALES: string;
}

export interface ICustomerDisplayController {
  startCustomerDisplay: (data: any) => void;
  closeCustomerDisplay: () => void;
  sendToCustomerDisplay: (data: any) => void;
  registerCustomerDisplayDataListener: (fn: Function) => void;
}

export interface IMainWindowController {
  sendToMainWindow: (data: any) => void;
  registerMainWindowDataListener: (fn: Function) => void;
}
